module.exports = __webpack_public_path__ + "graphics/player-rewind.ckh.d581ceeda0e0843b9f512e17e1762ccb.svg";